import { Lender, TLoanId } from '/src/lib/models';

/**
 * List Lenders
 */
export type TListLendersRequest = {
  loanId?: TLoanId;
};

export type TListLendersResponse = Lender[];

/**
 * Get Lender
 */
export type TGetLenderResponse = Lender;

/**
 * Deactivate Lender
 */
export type TDeactivateLenderResponse = Lender;
